var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_980_10072",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 8,
    height: 8
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 8,
    height: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_980_10072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4333 6.97501L9.01667 5.57501L9.48333 5.10834C9.61111 4.98056 9.76806 4.91667 9.95417 4.91667C10.1403 4.91667 10.2972 4.98056 10.425 5.10834L10.8917 5.57501C11.0194 5.70278 11.0861 5.85695 11.0917 6.03751C11.0972 6.21806 11.0361 6.37223 10.9083 6.50001L10.4333 6.97501ZM9.95 7.46667L6.41667 11H5V9.58334L8.53333 6.05001L9.95 7.46667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.a7ccceb00418bc0bfb1a86241f27402c.svg";
export { ForwardRef as ReactComponent };